module.exports = __webpack_public_path__ + "img/book_icon2.b7601088.png";